import { Route, Routes } from 'react-router-dom'
import { useFeaturesConfig } from 'builder/hooks/featureConfig/useFeaturesConfig'

import { Loading } from './Loading/Loading'
import { Onboarding } from './Onboarding/Onboarding'
import { Variant } from './types'

export const ProvisionUsers = () => {
  const { features } = useFeaturesConfig()
  const variant = features?.trLeadsV2

  return (
    <div data-testid="provision-users">
      <Routes>
        <Route path="loading" element={<Loading />} />
        <Route path="onboarding" element={<Onboarding variant={variant as Variant} />} />
      </Routes>
    </div>
  )
}
